/* import __COLOCATED_TEMPLATE__ from './collected-email-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();